module.exports = __webpack_public_path__ + "static/media/hotel_key.57cafc4b.svg";